import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { actions } from "../../actions/actionsWrapper";
import { eFoDangKyAnHocSinhActionTypeIds, IFoDangKyAnHocSinhActionTypes } from "../../action-types/thuc-don/IFoDangKyAnHocSinhActionTypes";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { IFoDangKyAnHocSinh } from "../../../models/response/thuc-don/IFoDangKyAnHocSinh";
import { IDangKyAnImportRequest } from "../../../models/request/thuc-don/IDangKyAnImportRequest";
import { NotifyHelper } from "../../../helpers/toast";

export function* foDangKyAnHocSinhSaga(): any {
    yield takeLatest(eFoDangKyAnHocSinhActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoDangKyAnHocSinhActionTypeIds.LOAD_BY_COSO_NAMHOC_START, loadByCoSoNamHocWorker)
    yield takeEvery(eFoDangKyAnHocSinhActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoDangKyAnHocSinhActionTypeIds.SAVE_IMPORT_START, saveImportWorker)
}

function* loadWorker(): any {
    try {
        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dangKyAnHocSinh.select_all)
        if (res.is_success) {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_SUCCESS(res.data))
        } else {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_ERROR(res.message ?? "Error"))
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_ERROR(error.message ?? "Unexpected error occurred"))
    }
}

function* loadByCoSoNamHocWorker(action: IFoDangKyAnHocSinhActionTypes): any {
    try {
        const payload = action.payload as { dm_coso_id: number; nam_hoc: string };

        if (!payload || !payload.dm_coso_id || !payload.nam_hoc) {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_BY_COSO_NAMHOC_ERROR("Invalid parameters"));
            return;
        }

        const res: IBaseResponeModel = yield call(
            apiWrapper.thucDonWrapper.dangKyAnHocSinh.select_by_coso_namhoc,
            payload.dm_coso_id,
            payload.nam_hoc
        );

        if (res.is_success) {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_BY_COSO_NAMHOC_SUCCESS(res.data));
        } else {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_BY_COSO_NAMHOC_ERROR(res.message ?? "Error"));
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dangKyAnHocSinh.LOAD_BY_COSO_NAMHOC_ERROR(error.message ?? "Unexpected error occurred"));
    }
}

function* saveWorker(action: IFoDangKyAnHocSinhActionTypes): any {
    try {
        const payload = action.payload as IFoDangKyAnHocSinh;

        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dangKyAnHocSinh.savechanges, payload);

        if (res.is_success) {
            NotifyHelper.Success("Lưu đăng ký ăn thành công");
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_SUCCESS(res.data))
            // Không reload data ở đây, để page tự reload thông qua handleRefresh
        } else {
            NotifyHelper.Error(res.message ?? "Có lỗi khi lưu đăng ký ăn");
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_ERROR(res.message ?? "Error"))
        }
    } catch (error: any) {
        NotifyHelper.Error(error.message ?? "Có lỗi không mong muốn");
        yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_ERROR(error.message ?? "Unexpected error occurred"))
    }
}

function* saveImportWorker(action: IFoDangKyAnHocSinhActionTypes): any {
    try {
        const payload = action.payload as IDangKyAnImportRequest;

        const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.dangKyAnHocSinh.SaveDataExcel, payload);

        if (res.is_success) {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_IMPORT_SUCCESS(res.data))
        } else {
            yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_IMPORT_ERROR(res.message ?? "Error"))
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.dangKyAnHocSinh.SAVE_IMPORT_ERROR(error.message ?? "Unexpected error occurred"))
    }
}
